module.exports = __webpack_public_path__ + "img/icon_group_6@2x.c5fb1dbe.png";